import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { UserBannerScreenUIProps } from 'hb-builder/components/BuilderComponents/block/UserBanner/types/userBannerScreenUIProps';
import {
  CircularProgressBarWrapper,
  ScreenUIButton,
} from 'hb-builder/components/BuilderComponents/block/UserBanner/UserBannerLayout/styles';

import DumbRoundedAvatar from './DumbRoundedAvatar';

const UserBannerLargeScreenUI = ({
  buttonAccount,
  buttonEvent,
  buttonPost,
  buttonPortfolio,
  ChildrenComponent,
  dataTestId,
  headline,
  image,
  profileCompletion,
  profileCompletionRate,
  shouldShowCompletionRate,
}: UserBannerScreenUIProps) => (
  <Wrapper data-testid={dataTestId}>
    {shouldShowCompletionRate && !image?.attributes?.hidden ? (
      <Box
        alignItems="center"
        justifyContent="center"
        height={112}
        flexShrink={0}
        position="relative"
        width={112}
        mt={4}
      >
        <CircularProgressBarWrapper
          position="absolute"
          maxWidth="inherit"
          percentage={profileCompletionRate}
          size={118}
          strokeWidth={3}
        />
        <DumbRoundedAvatar image={image} />
      </Box>
    ) : (
      <DumbRoundedAvatar image={image} />
    )}
    <StyledBox>
      <Title>
        <ChildrenComponent item={{ children: [headline] }} />
      </Title>
      {shouldShowCompletionRate && (
        <Box mt="3px" mb={3}>
          <ChildrenComponent item={{ children: [profileCompletion] }} />
        </Box>
      )}

      <ScreenUIButton>
        <ChildrenComponent
          item={{
            children: [buttonPost, buttonEvent, buttonPortfolio, buttonAccount],
          }}
        />
      </ScreenUIButton>
    </StyledBox>
  </Wrapper>
);

export default UserBannerLargeScreenUI;

const StyledBox = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
  ml: { xl: 5, l: 4 },
  alignItems: 'flex-start',
}))``;

const Title = styled(Box)`
  ${({ theme }) =>
    css`
      * {
        font-weight: ${theme.fontWeights[2]} !important;
      }
    `}
`;

const Wrapper = styled(Box).attrs({
  alignItems: 'start',
  py: 6,
})``;
